import { useState, useRef } from "react";
const FileUpload = (props) => {

    const inputRef = useRef(null);
    let validateProps = {
        required: {
            value: false,
            showFlag: true,
            errorMessage: ''
        }
    }

    if (props.validate)
        validateProps = props.validate

    //Local States
    const [isValid, setIsValid] = useState(true);
    const [validate, setValidate] = useState(validateProps);
    const [errorMessage, setErrorMessage] = useState("");
    const [files, setFiles] = useState("");
    const [value, setValue] = useState(null)
    

    const validateMethod = () => {
        let isValid = true
        let errorMessage = ''

        if (props.validate && props.validate.required && props.validate.required.value
            && files.length === 0) {
            isValid = false;
            if (props.validate.required.errorMessage && props.validate.required.errorMessage.length > 0) {
                errorMessage += errorMessage.length > 0 ? ', ' : ''
                errorMessage += props.validate.required.errorMessage
            }
        }

        setIsValid(isValid);
        setErrorMessage(errorMessage);

        return isValid;
    }

    return(
        <div className="form-group">
                {
                    props.label &&
                    <label htmlFor={props.id}>
                        {props.label}
                        {
                            validate && validate.required
                            && validate.required.value
                            && (validate.required.showFlag || true)

                            && <span className="text-danger"> *</span>
                        }
                    </label>
                }

                <input
                    ref={inputRef}
                    name={props.name}
                    className={
                        !isValid && validate &&
                            validate.required && validate.required.value
                            ? "form-control form-control-invalid" : "form-control"
                    }
                    type='file'
                    accept={props.accept}
                    id={props.id}
                    aria-describedby={`${props.id}-help`}
                    value={value}
                    onChange={(event) => {
                        
                        setFiles(event.target.value)
                        setIsValid(true);
                        if (props.onChange)
                            props.onChange(event)

                        
                        
                        //validate()
                    }}
                    onBlur={validateMethod}
                />

                {
                    !isValid &&
                    <small className="form-text text-danger">{errorMessage}</small>
                }
                {
                    props.helpText &&
                    <small id={`${props.id}-help`} className="form-text text-muted">{props.helpText}</small>
                }
            </div>
    )

}


export default FileUpload;